/**
 * Enum for applications.
 */
export const Application = {
    CHECKOUT: 'checkout',
    FAVOURITES: 'favourites',
    CART: 'cart',
    PROFILE: 'profile',
    MVAgent: 'mvagent',
    MiniIRW: 'mini-irw',
    RSSP: 'rssp',
};
